export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <svg viewBox="0 0 48 48" className="h-9 w-9 shrink-0" aria-hidden="true">
        <g fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 36 L13 15 L19 23 L27 9 L43 36" stroke="#7A8C80" strokeWidth="1.8" />
          <path d="M14 36 A11 11 0 0 1 36 36" stroke="#C4B5FD" strokeWidth="2" />
          <path d="M25 25 L17 36 M25 25 L33 36 M25 25 V36" stroke="#C4B5FD" strokeWidth="1.6" />
          <path d="M3 36 H45" stroke="#C4B5FD" strokeWidth="2" />
          <path d="M7.5 36 V25" stroke="#A78BFA" strokeWidth="1.8" />
        </g>
        <g fill="#A78BFA">
          <circle cx="7.5" cy="22.5" r="1.9" />
          <circle cx="5" cy="25.5" r="1.7" />
          <circle cx="10" cy="25.5" r="1.7" />
        </g>
      </svg>
      {!compact && (
        <span className="leading-tight">
          <span className="font-display text-lg tracking-[0.18em] uppercase block text-cream">Danseys Pass</span>
          <span className="font-mono text-[0.58rem] tracking-widest2 uppercase text-sage block">Lavender Farm</span>
        </span>
      )}
    </span>
  );
}
